<template>
	<div class="container position-relative">
		<div class="cm-loader py-5">
			<div class="amd-loader mt-5 mx-auto">
				<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 194.51 156.06">
					<path
						class="loader-icon"
						style="fill: #212121"
						d="M186.88,32.68A59.41,59.41,0,0,0,161.23,7.81C149.87,1.91,135.94,0,112.37,0H7.29L0,35.92l114.18-.22q15.45,0,24.31,10.31t7.95,27.11a55,55,0,0,1-6.5,24.2,43.58,43.58,0,0,1-15.23,16.35c-6.28,3.88-12.25,4.44-19.87,4.44l-33.07,0,13.1-65.26H40L19.3,156.06,95.36,156q27.33,0,49.4-10.86a88.36,88.36,0,0,0,35.17-30.47Q193,95.07,194.38,69.76q1.13-21.06-7.5-37.08"
					/>
				</svg>
				<div class="loading"></div>
				<div class="loader-text">Lade...</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'PageLoader',
}
</script>

<style scoped>
.cm-loader {
	background: transparent;
}
</style>
